import PropTypes from 'prop-types'

// Fills the modal body between header and footer instead of collapsing.
const Centered = ({ children }) => (
  <div
    style={{
      flex: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'var(--text-muted)',
      fontSize: 'var(--text-sm)',
      padding: 24,
      textAlign: 'center'
    }}
  >
    {children}
  </div>
)

Centered.propTypes = { children: PropTypes.node }

export default Centered
